/**
 * Class description
 *
 * Created: 2019-07-29
 * @author jonas
 */
import {ILayerConfig, ILayersConfig} from "@nolimitcity/slot-game/bin/core/stage/ILayersConfig";
import {IDeviceDependentConfig} from "@nolimitcity/slot-game/bin/core/useragent/UserAgent";
import {
    CustomLayerScaleOptions,
    LayerScaleOption,
    ScaleMethod,
    ScaleTarget
} from "@nolimitcity/slot-game/bin/core/stage/LayerScaleOption";


export interface IWinterHoardLayerConfig extends ILayersConfig {
    readonly BACKGROUND:ILayerConfig;
    readonly REEL_BACKGROUND:ILayerConfig;
    readonly REEL_ATTENTION:ILayerConfig;

    readonly BET_LINES:ILayerConfig;
    readonly WIN_PRESENTATIONS:ILayerConfig,
    readonly BIG_WIN:ILayerConfig;
    readonly WIN_COUNT_UP:ILayerConfig;
    readonly SCATTER_RAY:ILayerConfig;
    readonly EXTRA_FS:ILayerConfig;
}

export class WinterHoardLayerConfig {

    public static defaultLayerScaleOptions:IDeviceDependentConfig<LayerScaleOption> = {
        desktop : {
            landscape : LayerScaleOption.REELS_FIT_STAGE,
            portrait : LayerScaleOption.REELS_FIT_STAGE
        },
        mobile : {
            landscape : LayerScaleOption.REELS_FIT_STAGE,
            portrait : LayerScaleOption.REELS_FIT_STAGE
        }
    };

    public static customOptions:CustomLayerScaleOptions = {
        frame : {x : 0, y : 0, width : 720, height : 620},
        placement : {
            desktop : {
                landscape : {x : 0.5, y : 0.5}
            },
            mobile : {
                landscape : {x : 0.5, y : 0.5},
                portrait : {x : 0.5, y : 0.5}
            }
        },
    };


    public static reelBackground:CustomLayerScaleOptions = {
        target : {
            desktop : {
                landscape : ScaleTarget.STAGE
            },
            mobile : {
                landscape : ScaleTarget.STAGE,
                portrait : ScaleTarget.WINDOW
            }
        },
        placement : {
            desktop : {
                landscape : {x : 0.5, y : 1}
            },
            mobile : {
                landscape : {x : 0.5, y : 1},
                portrait : {x : 0.5, y : 1}
            }
        },
        method : {
            desktop : {
                landscape : ScaleMethod.FIT
            },
            mobile : {
                landscape : ScaleMethod.FIT,
                portrait : ScaleMethod.FIT
            }
        }

    };

    public static introConfig:CustomLayerScaleOptions = {
        target : ScaleTarget.WINDOW,
        method : ScaleMethod.FIT,
        frame : {x : 0, y : 0, width : 720, height : 720},
        placement : {x : 0.5, y : 0.5}
    };

    public static keypadConfig:CustomLayerScaleOptions = {
        target : ScaleTarget.WINDOW,
        method : ScaleMethod.FIT,
        frame : {x : 0, y : 0, width : 720, height : 720},
        placement : {x : 0.5, y : 1}
    };

    public static BACKGROUND:ILayerConfig = {name : "BACKGROUND", customOptions : WinterHoardLayerConfig.introConfig};

    public static FS_RAYS:ILayerConfig = {
        name : "FS_RAYS",
        customOptions : WinterHoardLayerConfig.customOptions
    };

    public static REEL_BACKGROUND:ILayerConfig = {
        name : "REEL_BACKGROUND",
        customOptions : WinterHoardLayerConfig.customOptions
    };

    public static REEL_ATTENTION:ILayerConfig = {
        name : "REEL_ATTENTIONS",
        customOptions : WinterHoardLayerConfig.customOptions
    };

    public static BET_LINES:ILayerConfig = {
        name : "BET_LINES",
        customOptions : WinterHoardLayerConfig.customOptions
    };
    public static SYMBOLS:ILayerConfig = {
        name : "symbols",
        customOptions : WinterHoardLayerConfig.customOptions
    };

    public static FREESPIN_COUNTERS:ILayerConfig = {
        name : "FREESPIN_COUNTERS",
        customOptions : WinterHoardLayerConfig.customOptions
    };

    public static INDICATOR_BG:ILayerConfig = {
        name : "INDICATOR_BG",
        customOptions : WinterHoardLayerConfig.customOptions
    };

    public static WIN_PRESENTATIONS:ILayerConfig = {
        name : "WIN_PRESENTATIONS",
        customOptions : WinterHoardLayerConfig.customOptions
    };

    public static WILD_OVERLAY:ILayerConfig = {
        name : "WILD_OVERLAY",
        customOptions : WinterHoardLayerConfig.customOptions
    };

    public static REEL_FRAME:ILayerConfig = {
        name : "REEL_FRAME",
        customOptions : WinterHoardLayerConfig.customOptions
    };


    public static WIN_COUNT_UP:ILayerConfig = {
        name : "WIN_COUNT_UP",
        customOptions : WinterHoardLayerConfig.customOptions
    };


    public static LOGO:ILayerConfig = {
        name : "LOGO",
        customOptions : WinterHoardLayerConfig.customOptions
    };

    public static BLAST_LANDSCAPE:ILayerConfig = {
        name : "BLAST_LANDSCAPE",
        customOptions : WinterHoardLayerConfig.customOptions
    };

    public static BLAST_PORTRAIT:ILayerConfig = {
        name : "BLAST_PORTRAIT",
        customOptions : WinterHoardLayerConfig.customOptions
    };


    public static DEBUG_OVERLAY:ILayerConfig = {name : "DEBUG_OVERLAY", scaleOption : LayerScaleOption.NONE};

    public static INTRO:ILayerConfig = {name : "intro", customOptions : WinterHoardLayerConfig.introConfig};

    public static WIN_LINES:ILayerConfig = {
        name : "WIN_LINES",
        customOptions : WinterHoardLayerConfig.customOptions
    };

    public static BIG_WIN:ILayerConfig = {
        name : "BIG_WIN",
        customOptions : WinterHoardLayerConfig.customOptions
    };


    public static MYSTERY_SYMBOL:ILayerConfig = {
        name : "MYSTERY_SYMBOL",
        customOptions : WinterHoardLayerConfig.customOptions
    };

    public static SCATTER_RAY:ILayerConfig = {
        name : "SCATTER_RAY",
        customOptions : WinterHoardLayerConfig.customOptions
    };

    public static EXTRA_FS:ILayerConfig = {
        name : "EXTRA_FS",
        customOptions : WinterHoardLayerConfig.customOptions
    };

    public static DEMO:ILayerConfig = {
        name : "DEMO",
        customOptions : WinterHoardLayerConfig.customOptions
    };

    public static FREESPIN_INTRO:ILayerConfig = {
        name : "FREESPIN_INTRO",
        customOptions : WinterHoardLayerConfig.customOptions
    };

    public static FULL_LIGHTNING:ILayerConfig = {
        name : "FULL_LIGHTNING",
        customOptions : WinterHoardLayerConfig.customOptions
    };

    public static getConfig():IWinterHoardLayerConfig {
        return {
            BACKGROUND : WinterHoardLayerConfig.BACKGROUND,
            REEL_BACKGROUND : WinterHoardLayerConfig.REEL_BACKGROUND,
            FS_RAYS : WinterHoardLayerConfig.FS_RAYS,
            REEL_ATTENTION : WinterHoardLayerConfig.REEL_ATTENTION,

            BET_LINES : WinterHoardLayerConfig.BET_LINES,
            SYMBOLS : WinterHoardLayerConfig.SYMBOLS,
            INDICATOR_BG : WinterHoardLayerConfig.INDICATOR_BG,
            REEL_FRAME : WinterHoardLayerConfig.REEL_FRAME,
            SCATTER_RAY : WinterHoardLayerConfig.SCATTER_RAY,


            FREESPIN_COUNTERS : WinterHoardLayerConfig.FREESPIN_COUNTERS,

            WIN_PRESENTATIONS : WinterHoardLayerConfig.WIN_PRESENTATIONS,
            WILD_OVERLAY : WinterHoardLayerConfig.WILD_OVERLAY,
            MYSTERY_SYMBOL : WinterHoardLayerConfig.MYSTERY_SYMBOL,

            BLAST_LANDSCAPE : WinterHoardLayerConfig.BLAST_LANDSCAPE,
            BLAST_PORTRAIT : WinterHoardLayerConfig.BLAST_PORTRAIT,

            FULL_LIGHTNING : WinterHoardLayerConfig.FULL_LIGHTNING,
            LOGO : WinterHoardLayerConfig.LOGO,

            WIN_LINES : WinterHoardLayerConfig.WIN_LINES,
            BIG_WIN : WinterHoardLayerConfig.BIG_WIN,
            WIN_COUNT_UP : WinterHoardLayerConfig.WIN_COUNT_UP,

            EXTRA_FS : WinterHoardLayerConfig.EXTRA_FS,

            DEBUG_OVERLAY : WinterHoardLayerConfig.DEBUG_OVERLAY,
            FREESPIN_INTRO : WinterHoardLayerConfig.FREESPIN_INTRO,
            INTRO : WinterHoardLayerConfig.INTRO,
            DEMO : WinterHoardLayerConfig.DEMO
        };
    }
}